import { action } from '@ember/object';
import Route from '@ember/routing/route';
import type PublicTransition from '@ember/routing/transition';
import { service } from '@ember/service';

import { hashSettled } from 'rsvp';

import type { Service } from 'webapp-types';

export default class MetricsCleanupRoute extends Route {
	@service('model-manager/metrics') declare mmMetricsService: Service.ModelManager.Metrics;
	@service('model-manager/custom-queries')
	declare mmCustomQueriesService: Service.ModelManager.CustomQueries;
	@service('model-manager/scripts') declare mmScriptsService: Service.ModelManager.Scripts;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('account') declare accountService: Service.Account;

	// Leaving closes the popup, and its close must not redirect that transition to /metrics.
	private isLeaving = false;

	override beforeModel(): Promise<unknown> {
		const promises: Record<string, Promise<unknown>> = {};

		promises.queries = this.mmCustomQueriesService.requestCustomQueries();

		promises.scripts = this.mmScriptsService.requestScripts();

		return hashSettled(promises);
	}

	override afterModel(): void {
		this.isLeaving = false;

		if (this.accountService.isDemoAccount) {
			void this.navigationService.replaceRoute('metrics');
		} else {
			void this.mmMetricsService.openUnusedMetricCleanupPopup().then(() => {
				if (!this.isLeaving) {
					void this.navigationService.replaceRoute('metrics');
				}
			});
		}
	}

	// Fires before the router's routeWillChange, where the navigation service closes all popups.
	@action
	override willTransition(_transition: PublicTransition): void {
		this.isLeaving = true;
	}
}
